import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AuthService } from '../../../services/auth.service';
import { PermissionsEnum } from '../../../api/api-reference';
import { ConfirmDialogComponent } from '../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-account-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet, ConfirmDialogComponent],
  templateUrl: './account-menu.component.html',
  styleUrl: './account-menu.component.scss',
})
export class AccountMenuComponent {
  isModalOpen = false;
  PermissionEnum=PermissionsEnum;
  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }

  logOut() {
    this.authService.logout();
  }
}
